import { useMemo, useState, useCallback } from "react";
import { Table } from "@skyportal/ui-kit";
import PaginationBox from "components/PaginationBox/PaginationBox";
import useOverviewBucketsColumnConfig from "hooks/useOverviewBucketsColumnConfig";
import { bucketsSortHandler } from "utils/sort";
import { bucketsMock } from "./mocks";

import styles from "../BucketsBlock.module.css";

const BucketsTable = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [sortField, setSortField] = useState<string>("");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("asc");

  const columnsConfig = useOverviewBucketsColumnConfig();

  const sortedData = useMemo(() => {
    if (!sortField) return [...bucketsMock];

    const sorter = bucketsSortHandler[sortField as keyof typeof bucketsSortHandler];
    if (!sorter) return [...bucketsMock];

    return [...bucketsMock].sort(sorter(sortOrder));
  }, [sortField, sortOrder]);

  const pageCount = Math.max(1, Math.ceil(sortedData.length / perPage));

  const paginatedData = useMemo(() => {
    const start = (currentPage - 1) * perPage;
    return sortedData.slice(start, start + perPage);
  }, [sortedData, currentPage, perPage]);

  const handlePerPageChange = useCallback((value: number) => {
    setPerPage(value);
    setCurrentPage(1);
  }, []);

  const handlePageChange = useCallback((value: number) => {
    setCurrentPage(value);
  }, []);

  const handleSortFieldChange = useCallback(
    (field: string) => {
      if (field === sortField) {
        setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
      } else {
        setSortField(field);
        setSortOrder("asc");
      }
    },
    [sortField]
  );

  return (
    <div className={styles.cardContent}>
      <div className={styles.tableBlock}>
        <Table
          dataSource={paginatedData}
          columns={columnsConfig}
          sortField={sortField}
          sortOrder={sortOrder}
          onSortFieldChange={handleSortFieldChange}
        />
      </div>

      <PaginationBox
        perPage={perPage}
        currentPage={currentPage}
        pageCount={pageCount}
        onPerPageChange={handlePerPageChange}
        onChangePage={handlePageChange}
      />
    </div>
  );
};

export default BucketsTable;
